import React from 'react';
import { formatCost } from '@/utils/chatCosts';

interface TokenUsageDisplayProps {
  inputTokens?: number;
  outputTokens?: number;
  reasoningTokens?: number;
  totalCost?: number;
  model?: string;
}

const TokenUsageDisplay: React.FC<TokenUsageDisplayProps> = ({
  inputTokens,
  outputTokens,
  reasoningTokens,
  totalCost,
  model
}) => {
  if (inputTokens === undefined && outputTokens === undefined && totalCost === undefined) return null;

  return (
    <div className="mt-1 text-xs text-muted-foreground space-y-0.5">
      {model && (
        <div className="font-mono text-[11px] opacity-70 mb-0.5">
          Model: {model}
        </div>
      )}
      <div className="flex items-center gap-3">
        {inputTokens !== undefined && (
          <span className="font-mono">
            In: {inputTokens.toLocaleString()}
          </span>
        )}
        {outputTokens !== undefined && (
          <span className="font-mono">
            Out: {outputTokens.toLocaleString()}
          </span>
        )}
        {reasoningTokens !== undefined && reasoningTokens > 0 && (
          <span className="font-mono">
            Reasoning: {reasoningTokens.toLocaleString()}
          </span>
        )}
        {totalCost !== undefined && (
          <span className="font-mono font-semibold">
            {formatCost(totalCost, false)}
          </span>
        )}
      </div>
    </div>
  );
};

export default TokenUsageDisplay;
